import { createRoute, Outlet } from "@tanstack/react-router";

import { rootRoute } from "../rootRoute";

// Pathless layout grouping /account-management/* and /content-library/*.
// Upload progress is tracked by the app-wide DocumentUploadProgressProvider in
// RootLayout (above the shell/noShell split), so both shelled and `noShell`
// children share a single provider instance.
// TODO: remove this pass-through once its children can parent to rootRoute directly.
export const uploadContextLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "_uploadContext",
  staticData: { pageName: "" },
  component: function UploadContextLayout() {
    return <Outlet />;
  },
});
